import ObexRequestsHandlerP80 from '../handlers/ObexRequestsHandlerP80';
import { Society } from '../types/Society.types';
import { getAccessToken, buildQuery, unwrapList } from './apiUtils';
import { mapCompanyAeat } from './CompanyAeatCredentialsService';

// Esta ruta sí está publicada, y usa guion (no guion bajo) como el resto de
// endpoints antiguos del gateway.
const ROUTES = {
  list: '/companies-list'
};

export const mapCompany = (raw: any): Society => ({
  id:      String(raw.id),
  name:    raw.name || '',
  cif:     raw.cif || '',
  address: raw.address || '',
  phone:   raw.phone || '',
  email:   raw.email || '',
  aeat:    mapCompanyAeat(raw)
});

export const listCompanies = async (
  options: { page?: number; pageSize?: number } = {}
): Promise<Society[]> => {
  const token = getAccessToken();
  if (!token) throw new Error('Sesión no válida o expirada.');

  const query = buildQuery({
    access_token: token,
    page:         options.page || 1,
    page_size:    options.pageSize || 100
  });

  const res = await ObexRequestsHandlerP80.get(`${ROUTES.list}${query}`);
  return unwrapList(res).map(mapCompany);
};
